import { render } from "./FeaturedProjects.vue?vue&type=template&id=9033dd20"
import script from "./FeaturedProjects.vue?vue&type=script&lang=js"
export * from "./FeaturedProjects.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brian/Documents/web-projects/clients/andy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__